// app and web entry
import App from "./App";
import "reflect-metadata";
import { AppRegistry, Platform } from "react-native";

// register the app
AppRegistry.registerComponent("BeeBondsWebConsole", () => App);

// register the web
if (Platform.OS === "web") {
    AppRegistry.runApplication("BeeBondsWebConsole", {
        rootTag: document.getElementById("root")
    });
}
